export enum SPACE_TYPE {
  'ONLY_DELIVERY' = 2,
  'SPACE_SHARE' = 1,
}
export const CONST_SPACE_TYPE = Object.values(SPACE_TYPE);
